import { render, staticRenderFns } from "./ShowcaseSection.vue?vue&type=template&id=6c0e1d8b&"
import script from "./ShowcaseSection.vue?vue&type=script&lang=ts&"
export * from "./ShowcaseSection.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports